interface StarProps {
  className?: string;
  /** Active = filled, Default = outline only */
  active?: boolean;
}

export function Star({ className = "", active = false }: StarProps) {
  return (
    <svg
      width="52"
      height="53"
      viewBox="0 0 52 53"
      fill="none"
      className={`shrink-0 ${className}`}
    >
      {active ? (
        <path
          d="M26 3l6.37 13.13L46 19.15l-10.4 10.14 2.47 14.43L26 37.24l-12.87 6.76 2.47-14.43L5.2 19.15l13.63-3.02L26 3z"
          fill="#FBAC00"
        />
      ) : (
        <path
          d="M26 3l6.37 13.13L46 19.15l-10.4 10.14 2.47 14.43L26 37.24l-12.87 6.76 2.47-14.43L5.2 19.15l13.63-3.02L26 3z"
          stroke="#FBAC00"
          strokeWidth="2"
        />
      )}
    </svg>
  );
}
